import axios from '../api'

const sendCouponInfos = params => {
  return axios({
    url: '/eos/coupon/sendCoupon/getSendCouponInfos',
    params
  })
}
const sendCouponDetailListInfos = params => {
  return axios({
    url: '/eos/coupon/sendCoupon/pageSendCouponRecord',
    params
  })
}

const sendCouponRecords = params => {
  return axios({
    url: '/eos/coupon/sendCoupon/getSendCouponRecords',
    params
  })
}

const getComboBoxByType = params => {
  return axios({
    url: '/eos/coupon/common/getComboBoxByType',
    params
  })
}

const getCouponAmounts = params => {
  return axios({
    url: '/eos/coupon/sendCoupon/getCouponAmounts',
    params
  })
}

const downloadFailPhonesFile = params => {
  return axios({
    url: '/eos/coupon/sendCoupon/downloadFailPhonesFile',
    params,
    responseType: 'blob'
  })
}
const downloadSendCouponInfos = params => {
  return axios({
    url: '/eos/coupon/sendCoupon/downloadSendCouponInfos',
    params
  })
}
const downloadSendCouponDetailListInfos = params => {
  return axios({
    url: '/eos/coupon/sendCoupon/downloadSendCouponRecord',
    params
  })
}
export default{
  sendCouponInfos,
  sendCouponDetailListInfos,
  sendCouponRecords,
  getComboBoxByType,
  getCouponAmounts,
  downloadFailPhonesFile,
  downloadSendCouponInfos,
  downloadSendCouponDetailListInfos
}
